import { Button, Modal, Row } from "react-bootstrap";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { MyTextInput } from "../../ui/controls/MyTextInput";
import { addRoomCategory } from "../../../store/slices/catalogue/thunks";
import { useDispatch, useSelector } from "react-redux";
import { MyTextArea2 } from "../../ui/controls/MyTextArea2";
import { MyDatePicker } from "../../ui/controls/MyDatePicker";
import { MySelect } from "../../ui/controls/MySelect";
import { MyTextInput66 } from "../../ui/controls/MyTextInput66";
import { onlyIntegers } from "../../../helpers/numericFields";


export const AddRoomCategory = ({ isOpen, setIsOpen, idHotel }) => {
  const dispatch = useDispatch();
  const { hotelsList } = useSelector((state) => state.general);

  return (
    <>
      <Modal
        size="xl"
        show={isOpen}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title >
            Agregar Categoria de Habitacion
          </Modal.Title>
          <Button
            onClick={() => setIsOpen(false)}
            className="btn-close"
            variant=""
          >
            x
          </Button>
        </Modal.Header>

        <Formik
          initialValues={{
            name: '',
            hotel: {value:0, label:"Seleccione un hotel"}
          }}
          onSubmit={(({ name, hotel }, { resetForm, setErrors }) => {
            const success = () => {
              resetForm();
              setIsOpen(false)
            }

            if (hotel.value === 0) {
              return setErrors({ "hotel": "Requerido" })
            }

            dispatch(addRoomCategory(name, hotel.value, success));

          })}
          validationSchema={
            Yup.object({
              name: Yup.string()
                .required("Requerido")
            })
          }
        >

          {
            ({ setFieldValue }) => (
              <Form>
                <Modal.Body>
                  <Row>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-6">
                        <MySelect label='Por hotel:' name="hotel" options={[{ value: 0, label: "Seleccione un hotel" }, ...hotelsList]} mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("hotel", e);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput label='Nombre:*' name='name' mode='horizontal' />
                      </div>
                    </div>
                  </Row>
                  <div style={{ fontSize: 13 }}>* Dato obligatorio</div>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="primary" type="submit">
                    Guardar Informacion
                  </Button>
                </Modal.Footer>
              </Form>
            )
          }
        </Formik>


      </Modal>
    </>
  );
}
